import { useRef } from "react";
import { AlertTemplate, CommunicationChannel } from "../../interfaces/IAlert";
import {Typography, useTheme} from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";

interface AlertEditorProps {
    template: AlertTemplate;
    setOpenPreviewDialog: (open: boolean) => void;
    onEditorChange: (editorRef: any) => void;
}

function AlertEditor({ template, setOpenPreviewDialog, onEditorChange }: AlertEditorProps) {
    const theme = useTheme();
    const isDarkTheme = theme.palette.mode === "dark";
    const editorRef = useRef<any>(null);
    const isSms = template.channel === CommunicationChannel.Sms;
    const toLongSms = template.editedText.length > 400;

    const editorInit = (template: AlertTemplate) => {
        if(template.channel === CommunicationChannel.Email){
            return {
                language: 'nb_NO',
                height: 800,
                menubar: false,
                skin: isDarkTheme ? 'oxide-dark' : 'oxide',
                content_css: isDarkTheme ? "dark" : "default",
                content_style: `body { background-color: ${theme.palette.background.paper}; color: ${theme.palette.text.primary}; }`,
                plugins: [
                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                ],
                toolbar: 'previewButton | blocks | ' +
                    'bold italic forecolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help | code',
                setup: function (editor: any) {
                    editor.ui.registry.addButton('previewButton', {
                        text: 'Preview',
                        onAction: function (_: any) {
                            setOpenPreviewDialog(true)
                        }
                    });
                },
            }
        }
        else{
            return {
                language: 'nb_NO',
                height: 300,
                menubar: false,
                skin: isDarkTheme ? 'oxide-dark' : 'oxide',
                content_css: isDarkTheme ? "dark" : "default",
                content_style: `body { background-color: ${theme.palette.background.paper}; color: ${theme.palette.text.primary}; }`,
                toolbar: 'previewButton',
                setup: function (editor: any) {
                    editor.ui.registry.addButton('previewButton', {
                        text: 'Preview',
                        onAction: function (_: any) {
                            setOpenPreviewDialog(true)
                        }
                    });
                },
            }
        }
    };

    return (
        <>
            <Editor
                key={isDarkTheme.toString() + template.channel + (template.language ?? '')}
                apiKey="d3gk806p6gful3y6imhwpo29m9mmgqljqi0wiz7cyg5vj6ae"
                onInit={(evt, editor) => editorRef.current = editor}
                value={template.text}
                onEditorChange={(content, editor) => { onEditorChange(editorRef.current) }}
                init={ editorInit(template) }
            />
            {isSms && <Typography  color={toLongSms ? 'error' : 'primary'} sx={{float: 'right'}} variant={"caption"}>{template.editedText.length} / 400</Typography>}
        </>
    )
}

export default AlertEditor;
